import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { poPdfLabelEditorQueryConfig } from '@webapp/modules/purchasing/query-configs/poPdfLabelEditor'
import {
  PDFLabelFieldMetadata,
  type PDFLabelFieldMetadataConstructor,
} from '@webapp/modules/vendor/entities/PDFLabelSet' // eslint-disable-line import/no-internal-modules

type UseQueryPOPDFLabelSetFieldsReturn = {
  fields: PDFLabelFieldMetadata[]
  isLoading: boolean
  error: RepoError | null
}

/**
 * Set-independent editor field metadata — the active set's saved overrides
 * arrive as a Presenter prop, so switching sets never refetches this query.
 */
export const useQueryPOPDFLabelSetFields =
  (): UseQueryPOPDFLabelSetFieldsReturn => {
    const { data, isLoading, error } = useQuery<
      PDFLabelFieldMetadataConstructor[],
      RepoError
    >(poPdfLabelEditorQueryConfig.editorFields())

    const fields = useMemo(
      () => (data ?? []).map((field) => new PDFLabelFieldMetadata(field)),
      [data]
    )

    return {
      fields,
      isLoading,
      error: error ?? null,
    }
  }
